<template>
  <CRow>
    <CCol col="12" xl="12">
      <transition name="slide">
      <CCard>
        <CCardHeader>
          <h4>Υπηρεσίες</h4>
          <CButton color="primary" class="btn m-3 btn-primary" @click="createService()">Προσθήκη υπηρεσίας</CButton>
          <CButton color="info" class="btn m-3" @click="$router.push('/services/groups')">Ομάδες Υπηρεσιών</CButton>
        </CCardHeader>
        <CCardBody>
          <CModal
            class="modalAlert"
            :show.sync="alertIsShown"
            :centered="true"
            size="lg"
          >
            <CAlert
              closeButton
              :show.sync="alertIsShown"
              color="primary"
              fade
            >
              {{ message }}
            </CAlert>
          </CModal>
          <CDataTable
            :items="items"
            :fields="fields"
            :items-per-page="10"
            pagination
            column-filter
            table-filter
            hover
            striped
            :loading="loading"
            sorter
            @row-clicked="(item) => showService(item.id)"
            clickable-rows
          >
          <template #status="{item}">
            <td>
              <CBadge>{{ item.status }}</CBadge>
            </td>
          </template>
          <template #actions="{item}">
            <td class="button-cell">
              <CButton
                color="primary"
                class="btn-icon mr-2"
                @click.stop="editService( item.id )"
                v-c-tooltip="'Επεξεργασία'"
              >
                <CIcon name="cilPencil" />
              </CButton>
              <CButton
                v-if="you!=item.id"
                color="danger"
                class="btn-icon"
                @click.stop="deleteService( item.id )"
                v-c-tooltip="'Διαγραφή'"
              >
                <CIcon name="cilTrash" />
              </CButton>
            </td>
          </template>
        </CDataTable>
        </CCardBody>
      </CCard>
      </transition>
    </CCol>
  </CRow>
</template>

<script>
import axios from 'axios'

const fields = [
  {
    key: 'name',
    label: 'Τίτλος'
  },
  {
    key: 'iaf_title',
    label: 'Standard name (IAF)'
  },
  {
    key: 'scheme_name',
    label: 'Scheme Name'
  },
  {
    key: 'iaf_prefix',
    label: 'Πρόθεμα IAF'
  },
  {
    key: 'group_name',
    label: 'Ομάδα'
  },
  {
    key: 'description',
    label: 'Περιγραφή'
  },
  {
    key: 'actions',
    label: '',
    sorter: false,
    filter: false
  }
]

export default {
  name: 'Services',
  data: () => {
    return {
      items: [],
      fields,
      currentPage: 1,
      perPage: 5,
      totalRows: 0,
      you: null,
      loading: true,
      message: '',
      showMessage: false,
      dismissSecs: 7,
      alertIsShown: false,
      dismissCountDown: 0,
      showDismissibleAlert: false
    }
  },
  paginationProps: {
    align: 'center',
    doubleArrows: false,
    previousButtonHtml: 'prev',
    nextButtonHtml: 'next'
  },
  watch: {
    alertIsShown: function(newVal, oldVal) {
      if (! newVal && this.saved) {
        this.$emit('closed-alert');
      }
    }
  },
  methods: {
    serviceLink (id) {
      return `services/${id.toString()}`
    },
    editLink (id) {
      return `services/${id.toString()}/edit`
    },
    showService ( id ) {
      const serviceLink = this.serviceLink( id );
      this.$router.push({path: serviceLink});
    },
    editService ( id ) {
      const editLink = this.editLink( id );
      this.$router.push({path: editLink});
    },
    deleteService ( id ) {
      let self = this;
      let userId = id;
      axios.post('/api/services/' + id + '?token=' + localStorage.getItem("api_token"), {
        _method: 'DELETE'
      })
      .then(function (response) {
          self.message = 'Επιτυχής διαγραφή υπηρεσίας.';
          self.showAlert();
          self.getServices();
      }).catch(function (error) {
        console.log(error);
        self.$router.push({ path: '/login' });
      });
    },
    createService () {
      this.$router.push({path: 'services/create'});
    },
    countDownChanged (dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    showAlert () {
      this.alertIsShown = true
    },
    getServices (){
      let self = this;
      axios.get('/api/services?token=' + localStorage.getItem("api_token"))
      .then(function (response) {
        self.items = response.data.services;
        self.loading = false;
        self.you = response.data.you;
      }).catch(function (error) {
        console.log(error);
        self.loading = false;
        self.$router.push({ path: '/login' });
      });
    }
  },
  mounted: function(){
    this.getServices();
  }
}
</script>
